import { createRoute } from '@tanstack/react-router';
import { PujcovnaUhradyPage } from '@/modules/pujcovna/PujcovnaUhradyPage';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/pujcovna/uhrady',
  component: PujcovnaUhradyPage,
});
